// Helpers for default step names and sibling-collision suffixing.

import type { Pipeline, Step, StepType } from './types';

export function defaultNameForType(type: StepType): string {
  switch (type) {
    case 'input':
      return 'Input';
    case 'greyscale':
      return 'Greyscale';
    case 'color_separate':
      return 'Color Separation';
    case 'channel':
      return 'Channel';
    case 'gradient_sep':
      return 'Gradient Separation';
    case 'band':
      return 'Band';
    case 'halftone':
      return 'Halftone';
  }
}

// Given a desired name and the set of existing sibling names under the same
// parent, return either the desired name (if free) or a `name (n)` variant.
export function disambiguate(
  desired: string,
  siblings: ReadonlyArray<string>,
): string {
  const taken = new Set(siblings);
  if (!taken.has(desired)) return desired;
  for (let i = 2; i < 1000; i++) {
    const candidate = `${desired} (${i})`;
    if (!taken.has(candidate)) return candidate;
  }
  return `${desired} (${Date.now()})`;
}

export function siblingNamesOf(
  pipeline: Pipeline,
  parentId: string,
): string[] {
  const parent = pipeline.steps[parentId];
  if (!parent) return [];
  const names: string[] = [];
  for (const childId of parent.children) {
    const c: Step | undefined = pipeline.steps[childId];
    if (c) names.push(c.name);
  }
  return names;
}
